import axios, { AUTH_PREFIX } from 'src/clients/axios';
import { ProductStatusGetRsData } from 'src/models/Client';

export const GET_PRODUCT_STATUS_URL = `${AUTH_PREFIX}/account/product-status`;

export function getProductStatus() {
  return axios.get<ProductStatusGetRsData>(GET_PRODUCT_STATUS_URL);
}
